<template>
  <div>
    <div class="resources-activate">
      <div class="resources-header">
        <img src="@/assets/images/website/home/jl.png" alt="" />
        {{ list.name }}
      </div>
      <div class="card-item" v-for="(item, index) in list.label" :key="index">
        <div class="title">
          {{ item.title }}
        </div>
        <div class="desc">
          {{ item.detail }}
        </div>
      </div>
      <div class="more" @click="windowOpen(list.path)">
        查看更多<img src="@/assets/images/website/home/moreRight.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    windowOpen(path) {
      console.log(path)
      window.open(path, '_blank')
    }
  }
};
</script>

<style lang="less" scoped>
.resources-activate {
  width: 512px;
  box-sizing: border-box;
  position: relative;
  height: 500px;
  background: #f1f5fb;
  border-radius: 2px;
  border: 1px solid #ffffff;
  padding: 24px;
  background: url("@/assets/images/website/home/resources.png") no-repeat;
  background-size: 100% 100%;

  .resources-header {
    display: flex;
    align-items: center;

    img {
      margin-right: 16px;
      width: 24px;
      height: 24px;
    }

    font-size: 18px;
    font-family: PingFangSC-Semibold,
    PingFang SC;
    font-weight: 600;
    color: #354052;
    margin-bottom: 24px;
  }

  .card-item {
    transition: all 0.3s ease;
    width: 460px;
    margin-bottom: 16px;
    padding: 8px 12px;
    box-sizing: border-box;
    background: linear-gradient(135deg,
        rgba(255, 255, 255, 0.6) 0%,
        rgba(255, 255, 255, 0) 100%);
    border-radius: 2px;
    border: 1px solid #ffffff;

    .title {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #354052;
    }

    .desc {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4b5b76;
      line-height: 20px;
    }
  }

  .more {
    position: absolute;
    bottom: 30px;
    cursor: pointer;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #354052;
    display: flex;
    align-items: center;

    img {
      margin-left: 6px;
      width: 20px;
      height: 14px;
    }
  }
}
</style>